'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var checkIn = require('./check-in-d150c6e9.js');
var confirmed = require('./confirmed-45bc4a9e.js');

var CheckInContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var CheckedInContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-style: italic;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n\n  svg path{\n    fill: ", "\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-style: italic;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n\n  svg path{\n    fill: ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var StyledCheckIn = styled__default(checkIn.CheckIn)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin-right: 4px;\n"], ["\n  margin-right: 4px;\n"])));
var StyledConfirmed = styled__default(confirmed.Confirmed)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  margin-right: 4px;\n"], ["\n  margin-right: 4px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var CheckInBlock = function (_a) {
    var isCheckedIn = _a.isCheckedIn, checkInText = _a.checkInText, onClick = _a.onClick, _b = _a.dataTestId, dataTestId = _b === void 0 ? 'check-in-block' : _b;
    return (React__default.createElement("div", { "data-testid": dataTestId, "aria-hidden": "true", onClick: onClick }, isCheckedIn ? (React__default.createElement(CheckedInContainer, null,
        React__default.createElement(StyledConfirmed, { size: "sm" }),
        checkInText)) : (React__default.createElement(CheckInContainer, null,
        React__default.createElement(StyledCheckIn, { size: "m/l" }),
        checkInText))));
};
CheckInBlock.defaultProps = {
    isCheckedIn: false,
    checkInText: null,
    onClick: null,
    dataTestId: 'check-in-block',
};

exports.CheckInBlock = CheckInBlock;
